/* eslint-disable */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material'
import { useState, useEffect } from 'react'
import TextfieldAndUpload from './FileUploadAndList'
import { useApiGet, useApiPost } from '../../apiCalls/useApi'
import { getUserName } from '../../apiCalls/dashboardApi'
import { createBreachAction, updateBreachAction } from '../../apiCalls/breachApi'

interface ActionData {
  id?: number
  actionName: string
  timestamp: string
  username: string
  description: string
  notes: string
  attachments: any[]
}

interface ActionDialogProps {
  open: boolean
  onClose: () => void
  data?: ActionData
  phase: string
  breachId: string
  setUpdateFlag: React.Dispatch<React.SetStateAction<number>>
}

export default function ActionDialog({
  open,
  onClose,
  data,
  phase,
  breachId,
  setUpdateFlag,
}: ActionDialogProps) {
  const [formData, setFormData] = useState<ActionData>({
    actionName: '',
    timestamp: new Date().toISOString(),
    username: '',
    description: '',
    notes: '',
    attachments: [],
  })

  const fetchUserName = useApiGet(getUserName)
  const createAction = useApiPost(createBreachAction)
  const updateAction = useApiPost(updateBreachAction)

  useEffect(() => {
    if (data) {
      setFormData(data)
    }
    fetchUserName().then((res) => {
      if (!res || res.error || !res.firstname || !res.lastname) return
      const { firstname, lastname } = res
      setFormData((prev) => ({ ...prev, username: `${firstname} ${lastname}` }))
    })
  }, [data, open])

  const handleSubmit = () => {
    if (data) {
      updateAction({
        ...formData,
      }).then((res: any) => {
        if (res?.error) return
        setUpdateFlag((prev: number) => prev + 1)
        onClose()
      })
    } else {
      createAction({
        ...formData,
        phase,
        breachId,
      }).then((res: any) => {
        console.log('show createAction', res)
        if (res?.error) return
        setFormData({
          actionName: '',
          timestamp: new Date().toISOString(),
          username: '',
          description: '',
          notes: '',
          attachments: [],
        })
        setUpdateFlag((prev: number) => prev + 1)
        onClose()
      })
    }
  }

  const handleClose = () => {
    onClose()
    setFormData({
      actionName: '',
      timestamp: new Date().toISOString(),
      username: '',
      description: '',
      notes: '',
      attachments: [],
    })
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
      <DialogTitle>{data ? 'Action Details' : 'Create New Action'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label='Action'
            fullWidth
            value={formData.actionName}
            onChange={(e) => setFormData((prev) => ({ ...prev, actionName: e.target.value }))}
          />
          <TextField
            label='Timestamp'
            fullWidth
            disabled
            value={formData.timestamp}
            onChange={(e) => setFormData((prev) => ({ ...prev, timestamp: e.target.value }))}
          />
          <TextField
            label='Username'
            fullWidth
            value={formData.username}
            onChange={(e) => setFormData((prev) => ({ ...prev, username: e.target.value }))}
          />
          <TextField
            label='Description'
            fullWidth
            multiline
            rows={4}
            value={formData.description}
            onChange={(e) => setFormData((prev) => ({ ...prev, description: e.target.value }))}
          />
          <TextField
            label='Notes'
            fullWidth
            multiline
            rows={4}
            value={formData.notes}
            onChange={(e) => setFormData((prev) => ({ ...prev, notes: e.target.value }))}
          />
          <TextfieldAndUpload
            fileList={formData.attachments}
            // fileList={formData.attachments}
            // setFileList={setFormData((prev) => ({ ...prev, attachments: e.target.value }))}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant='contained' color='primary'>
          {data ? 'Save' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
